import { COLOR_PALETTE_FROM_IMAGE } from '@quicktools/shared-components';

export const BASE_URL = `${process.env.NX_DEPLOY_PATH}${process.env.NX_DEPLOY_SUFFIX}`;
export const VERSION = process.env.NX_APP_VERSION;

export const TOOL_NAME = COLOR_PALETTE_FROM_IMAGE.id;

export const TRACKING_ID = process.env.NX_TRACKING_ID;
export const TRACKING_ID_4 = process.env.NX_TRACKING_ID_4;
export const HOTJAR_ID = Number(process.env.NX_HOTJAR_ID);
export const BUGSNAG_ID = process.env.NX_BUGSNAG_ID;
export const OPTIMIZE_ID = process.env.NX_OPTIMIZE_ID;
export const ONETRUST_ID = process.env.NX_ONETRUST_ID;

export const appConfig = {
  accept: 'image/heic,image/png,image/jpg',
  multiple: false,
  logoUrl: 'https://cdn140.picsart.com/49894013487021829199.svg',
  suggestedImgData: [
    {
      src: 'https://cdn140.picsart.com/11775159747107319381.jpg?to=min&r=48',
      alt: 'Nike shoe',
    },
    {
      src: 'https://cdn140.picsart.com/96280782516210923197.jpg?to=min&r=48',
      alt: 'Lipstick',
    },
    {
      src: 'https://cdn140.picsart.com/27031210475996425006.jpg?to=min&r=48',
      alt: 'Friends',
    },
    {
      src: 'https://cdn140.picsart.com/91770161942854590448.jpg?to=min&r=48',
      alt: 'Tenis ball',
    },
  ],
} as const;
